<template>
<div class="row mt-5">
    <div class="col-2 " v-for="column in columnsSelected">
        <label>{{ getTrans(column) }}</label>
        <v-select style="width: 90%" class="vue-select" multiple v-model="globalFilters[column]" :options="getOptionsForColumn(column)">
        </v-select>
    </div>
    <div class="col-2 ">
        <label>{{ __('checked_checkbox') }}</label>
        <v-select style="width: 90%" class="vue-select" multiple v-model="globalFilters['checked']" :options="getOptionsForColumn('checked_checkbox')">
        </v-select>
    </div>

    <div class="col-12 text-left mt-2">
        <button class="btn btn-primary btn-sm btn-reset-filters" @click="resetButtonClicked()"
           style="text-transform : capitalize;">{{ __('filter_reset') }}</button>
        <button style="text-transform : capitalize" type=submit class="btn btn-primary btn-sm" @click="filterButtonClicked()">{{ __('filter') }}</button>
    </div>
</div>
</template>

<script>
import {getTransForAnalyze} from "./mixin";
import {Money} from "../../services/Money";

export default {
    name: "GlobalAnalyzeFilter",
    mixins: [getTransForAnalyze],
    props:{
        globalFilters:{
            type: Object
        },
        columnsSelected:{
            type: Array
        },
        documents:{
            type: Array
        }
    },
    data:function (){
        return {
            money: new Money()
        }

    },
    methods:{
        resetButtonClicked(){
            this.$emit('resetButtonClicked');
        },
        filterButtonClicked(){
            this.$emit('filterButtonClicked');
        },
        getTrans(column){
            return this.getTransColumn(column)
        },
        isMoney(column){
            return this.isMoneyFormat(column)
        },
        getValue(column, document){
            if(column.includes('_id')){
                column = column.replace('_id', '_display');
            }
            if(this.isMoney(column)){
                if(document[column] !== '' && document[column] !== '-'){
                    return this.money.localize(document[column])
                }
                else if(document[column] === '-')
                {
                    return document[column];
                }
                return '';
            }
            else{
                return document[column];
            }
        },
        getOptionsForColumn(column) {
            if(column != 'checked_checkbox'){
                const optionsMap = new Map();
                this.documents.forEach((document) => {
                    if(document[column]){
                        const label = this.getValue(column, document);
                        const id = document[column];

                        // Dodaj do mapy, unikalne wartości będą nadpisywane
                        optionsMap.set(label, { label, id });
                    }

                });
                return [...optionsMap.values()];
            }
            return [{'label':this.__('yes'), id:true}, {'label':this.__('no_upper'), id:false}]

        },
    },
    computed: {

    },
    mounted() {
    }
}
</script>

<style scoped>

</style>
